import { type ReactNode } from 'react';
import { Lock } from 'lucide-react';
import { ROLE_DESCRIPTIONS } from '../data/role-descriptions';

const FAKE_COUNT = 4;

function FakeCard(): ReactNode {
  return (
    <div className="flex aspect-square w-full items-center justify-center rounded-lg bg-surface-elevated">
      <Lock size={40} className="text-[#393939]" />
    </div>
  );
}

function ComingSoonHeader({ role }: { role: string }): ReactNode {
  const info = ROLE_DESCRIPTIONS[role];
  return (
    <div className="flex flex-col gap-xs border-b border-white/[0.06] pb-sm">
      <div className="flex items-baseline gap-sm">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-text-secondary">
          {info?.title ?? role}
        </h3>
        <span className="text-[11px] font-semibold uppercase tracking-wider text-brand-red">
          Próximamente…
        </span>
      </div>
      {info?.description && (
        <p className="max-w-[42rem] text-xs leading-relaxed text-text-tertiary">
          {info.description}
        </p>
      )}
    </div>
  );
}

function ApplyBtn(): ReactNode {
  return (
    <button
      disabled
      aria-disabled="true"
      className="cursor-not-allowed rounded-md bg-surface-secondary px-xl py-sm text-sm font-semibold text-text-tertiary opacity-70"
    >
      Aplicar
    </button>
  );
}

export function ComingSoonSection({ role }: { role: string }): ReactNode {
  return (
    <section>
      <ComingSoonHeader role={role} />
      <div className="mt-md grid grid-cols-2 gap-md sm:grid-cols-3 lg:grid-cols-4 lg:gap-base xl:grid-cols-5">
        {Array.from({ length: FAKE_COUNT }).map((_, i) => (
          <FakeCard key={i} />
        ))}
      </div>
      <div className="mt-lg flex justify-center">
        <ApplyBtn />
      </div>
    </section>
  );
}
